<template>
  <div class="view-mode">
    <div class="view-mode-columns">
      <div class="labels__view-mode">
        <div
          class="general_info_holder"
          v-for="(info, index) in generalInfo"
          :key="index"
        >
          <p>{{ info.name }} : {{ info.value }}</p>
        </div>
        <div
          class="general_info_holder"
          v-if="studentData.isApproved !== null"
          :class="studentData.isApproved ? '' : 'status-danger'"
        >
          <p>
            Student has
            <span v-if="!studentData.studentApproved">NOT</span> approved email
          </p>
        </div>
        <b-notification
          v-if="!studentData.isAdminApproved"
          type="is-danger is-light"
          aria-close-label="Close notification"
          role="alert"
        >
          Student will require admin approval due to:

          <ul>
            <li
              v-for="(issue, issueKey) in studentData.adminStudentIssues"
              :key="issueKey"
            >
              {{ issue.message }}
              <div
                v-if="issue.type === 'repeatStudent' && UtilService.isAdmin()"
              >
                <b-button
                  v-for="(student, index) in issue.data"
                  :key="index"
                  tag="router-link"
                  :to="{
                    name: 'view-student',
                    params: {
                      id: student.id,
                      applicationId: student.app_id,
                      routeIsEdit: false,
                    },
                  }"
                  type="is-success"
                >
                  View
                </b-button>
              </div>
            </li>
          </ul>
        </b-notification>
      </div>

      <div class="course__view-mode">
        <h3 class="edit-title">Course details</h3>
        <div class="content">
          <p><b>Course:</b> {{ course.name }}</p>
          <p><b>University:</b> {{ course.university }}</p>
          <p><b>City:</b> {{ course.city }}</p>
          <p><b>Delivery mode:</b> {{ course.delivery }}</p>
          <p>
            <b>{{ hasDiploma() }}</b>
          </p>

          <p><b> Student preferences </b></p>

          <p>
            <b>Delivery mode:</b>
            {{ studentData.personalInformation.delivery_mode }}
          </p>
          <p>
            <b>Timetable:</b> {{ studentData.personalInformation.timetable }}
          </p>
        </div>
      </div>

      <div class="application__view-mode">
        <h3 class="edit-title">Aplication information</h3>
        <div v-if="studentData.applicationInformation" class="content">
          <p>
            <b>Previously applied for Student Finance:</b>
            {{ studentData.applicationInformation.studentFinanceApplied }}
          </p>
          <p>
            <b>Does the student have a diploma:</b>
            {{ studentData.applicationInformation.diploma }}
          </p>
          <p>
            <b>English qualification:</b>
            {{ studentData.applicationInformation.english_qualifications }}
          </p>
        </div>
      </div>

      <div class="student__view-mode">
        <h3 class="edit-title">Student information</h3>
        <div class="content">
          <p><b>Name:</b> {{ studentName(studentData.personalInformation) }}</p>
          <p>
            <b>Date of Birth:</b>
            {{
              this.convertDate(studentData.personalInformation.date_of_birth)
            }}
          </p>
          <p>
            <b>Nationality:</b>
            {{ studentData.personalInformation.nationality }}
          </p>
          <p>
            <b>Country of Birth:</b>
            {{ studentData.personalInformation.birth_country }}
          </p>
          <p><b>Gender:</b> {{ studentData.personalInformation.gender }}</p>
          <p>
            <b>Phone:</b> {{ studentData.personalInformation.phone_number }}
          </p>
          <p><b>Email:</b> {{ studentData.personalInformation.email }}</p>
          <p>
            <b>Address:</b>
            {{ studentAddress(studentData.personalInformation) }}
          </p>
          <p>
            <b>Year of course:</b>
            {{ studentData.personalInformation.year_of_course }}
          </p>
          <p
            v-if="
              studentData.personalInformation.emergency_contact &&
              studentData.personalInformation.emergency_contact.length
            "
          >
            <b>Emergency contact:</b>
            {{ studentData.personalInformation.emergency_contact }}
          </p>
          <p v-else>
            <span>
              <b>Emergency contact name:</b>
              {{ studentData.personalInformation.emergency_contact_name }}
            </span>
            <span>
              <b>Emergency contact phone:</b>
              {{ studentData.personalInformation.emergency_contact_phone }}
            </span>
            <span>
              <b>Emergency contact relationship:</b>
              {{
                studentData.personalInformation.emergency_contact_relationship
              }}
            </span>
          </p>
          <p>
            <b>Intreview date availability:</b>
            {{ studentData.personalInformation.interview_date_availability }}
          </p>
          <p>
            <b>Found the student on:</b>
            {{ studentData.personalInformation.student_referal }}
          </p>
        </div>
      </div>

      <div class="residence__view-mode">
        <h3 class="edit-title">Residence information</h3>
        <div v-if="studentData.applicationInformation" class="content">
          <p>
            <b>EU Settlement Status:</b>
            {{ studentData.applicationInformation.setttlement_status }}
          </p>
          <p>
            <b>Employment Status:</b>
            {{ studentData.applicationInformation.employment_status }}
          </p>
          <p>
            <b>Share Code:</b>
            {{ studentData.applicationInformation.share_code }}
          </p>
          <p>
            <b>UK Entry date:</b>
            {{
              this.convertDate(studentData.applicationInformation.uk_entry_date)
            }}
          </p>
          <p>
            <b>Application route:</b>
            {{ studentData.applicationInformation.application_route }}
          </p>
          <p>
            <b>NINO Number:</b>
            {{ studentData.applicationInformation.nino_number }}
          </p>
          <p>
            <b>Highest education institution name graduated:</b>
            {{ studentData.applicationInformation.education_institution_name }}
          </p>
        </div>
      </div>

      <div class="docs__view-mode" v-if="course.id">
        <h3 class="edit-title">Uploaded documents</h3>
        <b-button @click="uploadMore" class="upload-more mx-0 mb-2" rounded
          >Upload more</b-button
        >
        <div class="divider"></div>
        <div
          class="doc-title-holder doc-title-holder__view-mode"
          v-for="(file, index) in orderedDocs"
          :key="index"
        >
          <app-doc-icon :document="file.name"></app-doc-icon>
          <p class="doc-title" :title="file.name">{{ file.name }}</p>
        </div>
      </div>

      <div class="message__view-mode" v-if="getActiveConversation.id">
        <student-message />
      </div>
    </div>

    <!-- <div class="view-mode-messages" v-if="getActiveConversation.id">
        <student-message />
    </div> -->

    <div v-if="application.id" class="floating-menu floating-menu-2">
      <b-icon
        @click.native.prevent="isEdit = false"
        icon="book"
        size="is-small"
        type="is-white"
      ></b-icon>
      <b-tooltip
        label="Change edit mode"
        class="floating-menu-tooltip"
        @click.native.prevent="changeViewMode(1)"
      >
        2 lines
      </b-tooltip>
    </div>

    <div v-if="application.id" class="floating-menu floating-menu-4">
      <b-icon
        @click.native.prevent="$router.go(-1)"
        icon="arrow-left"
        size="is-small"
        type="is-white"
      ></b-icon>
      <b-tooltip
        label="Go back"
        class="floating-menu-tooltip"
        @click.native.prevent="$router.go(-1)"
      >
        2 lines
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import AppDocIcon from '../helpers/DocIcon.vue';
import moment from 'moment';
import StudentMessage from '../messaging/StudentMessage.vue';
import UtilService from '../../services/util';

export default {
  name: 'student-view-mode',
  components: {
    AppDocIcon,
    StudentMessage,
  },
  props: ['studentData', 'studentDocuments', 'application', 'course'],
  data() {
    return {
      generalInfo: [],
    };
  },
  created() {
    this.generalInfo = Object.entries(this.studentData.generalInfo)
      .map(([name, value]) => {
        return this.convertValue(value)
          ? {
              name: this.convertName(name),
              value: this.convertValue(value),
            }
          : null;
      })
      .filter((el) => {
        return el != null;
      });

    if (this.course.documents) {
      this.$store.dispatch('application/setActiveConversation', {
        id: this.application.id,
        studentId: this.application.studentId,
        courseDocuments: this.course.documents.map((doc) => doc.name),
        studentName: UtilService.studentName(
          this.studentData.personalInformation
        ),
        courseTitle: this.course.name,
        moderatorId: this.application.moderatorId,
        isApproved: this.studentData.isApproved,
      });
    }
  },
  computed: {
    orderedDocs() {
      const newList = this.studentData.documents.list;
      return newList.sort((a, b) => {
        return b.lastModified - a.lastModified;
      });
    },

    getActiveConversation() {
      return UtilService.getActiveConversation();
    },
  },
  watch: {},
  methods: {
    hasDiploma() {
      if (
        !this.studentData.applicationInformation ||
        this.studentData.applicationInformation.diploma === null ||
        this.studentData.applicationInformation.diploma === 'No' ||
        this.studentData.applicationInformation.diploma === undefined
      ) {
        return 'Student is NOT applying with a diploma';
      } else {
        return 'Student is applying with a diploma';
      }
    },

    convertName(string) {
      let newString = string.charAt(0).toUpperCase() + string.slice(1);
      newString = newString.replace(/_/g, ' ');
      return newString;
    },

    convertValue(value) {
      let newValue = value.length > 0 ? value : null;
      return newValue;
    },

    studentName(student) {
      return (
        student.title + ' ' + student.first_name + ' ' + student.last_name + ' '
      );
    },

    studentAddress(student) {
      return (
        student.street_address +
        ' ' +
        student.house_number +
        ' ' +
        student.city +
        ' ' +
        student.zip_code +
        ' '
      );
    },

    convertDate(deadline) {
      if (deadline == null) {
        return deadline;
      } else {
        return moment(deadline).format('DD-MM-YYYY');
      }
    },

    uploadMore() {
      this.changeViewMode(4);
    },

    changeViewMode(activeTab) {
      this.$emit('changed', {
        isEdit: true,
        activeTab,
      });
    },
  },
};
</script>

<style>
/* .view-mode {
    display: flex;
    flex-direction: row;
} */

/* .view-mode-columns {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
} */

.view-mode-columns {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto;
  gap: 7px 7px;
  grid-template-areas:
    'labels__view-mode labels__view-mode message__view-mode'
    'docs__view-mode docs__view-mode message__view-mode'
    'course__view-mode application__view-mode message__view-mode'
    'student__view-mode residence__view-mode message__view-mode';
}

.view-mode-columns > div {
  padding: 20px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.12),
    0 4px 4px rgba(0, 0, 0, 0.12), 0 8px 8px rgba(0, 0, 0, 0.12),
    0 16px 16px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin: 10px;
}

h3.edit-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
  border-bottom: 2px solid #000;
  padding-bottom: 5px;
  text-transform: uppercase;
}

.labels__view-mode {
  grid-area: labels__view-mode;
  display: inline-flex;
  flex-wrap: wrap;
}

.view-mode-columns > div.message__view-mode {
  box-shadow: none;
  grid-area: message__view-mode;
}

.course__view-mode {
  grid-area: course__view-mode;
}

.application__view-mode {
  grid-area: application__view-mode;
}

.student__view-mode {
  grid-area: student__view-mode;
}

.residence__view-mode {
  grid-area: residence__view-mode;
}

.docs__view-mode {
  grid-area: docs__view-mode;
  display: flex;
  flex-wrap: wrap;
}

.docs__view-mode .edit-title {
  flex: 0 0 100%;
}

.docs__view-mode > .divider {
  flex: 0 0 100%;
}

.golden-rectangle {
  position: relative;
  margin-top: 30px;
  width: fit-content;
  max-width: 30%;
  max-height: 50vh;
  overflow-y: scroll;
}

.golden-rectangle .content {
  background-color: #ede5d3;
  border: 2px solid;
  padding: 12px;
  border-radius: 12px;
}

.golden-rectangle .edit-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
}

.doc-title-holder__view-mode {
  margin-bottom: 20px;
  min-width: 50%;
  max-width: 50%;
  position: relative;
}

.upload-more.button {
  background-color: #f9b040;
  color: white;
  display: flex;
  margin: 0 auto;
}

.general_info_holder {
  background-color: #456df0;
  display: flex;
  align-items: center;
  color: #fff;
  font-weight: 700;
  border-radius: 10px;
  padding: 8px;
  position: relative;
  min-width: 100px;
  height: 36px;
  width: fit-content;
  margin: 8px 8px 0 0;
}

.general_info_holder .small-title {
  position: absolute;
  top: -23px;
  left: 0;
  font-weight: 700;
}

.view-mode-messages {
  min-width: 400px;
  max-width: 500px;
}
</style>
